(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["why-choose"] && !Shopify.designMode) return;
  try {
    
// No JS required for layout — but keep a tiny script to add ARIA attributes and ensure images present
document.addEventListener('DOMContentLoaded', function(){
  var section = document.getElementById('why-choose-theliwala-{{ section.id }}');
  if(!section) return;
  // add role and aria-label for screen readers
  section.setAttribute('aria-label', '{{ section.settings.heading | escape }}');

  // if any card has no image, reduce top padding so it looks balanced
  var cards = section.querySelectorAll('.feature-item');
  cards.forEach(function(card){
    var img = card.querySelector('img');
    if(!img){
      card.style.paddingTop = '28px';
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
